jQuery(function ($) {
	console.log('Footer script loaded.');
	// Footer logo carousel (Slick)
	if ($.fn && typeof $.fn.slick === 'function') {
		var $slider = $('.footer-carousel__slick').first();
		if ($slider.length && !$slider.hasClass('slick-initialized')) {
			$slider.slick({
				dots: false,
				arrows: false,
				infinite: true,
				variableWidth: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 0,
				speed: 9000,
				cssEase: 'linear',
				pauseOnHover: false,
				pauseOnFocus: false,
				swipe: false,
				draggable: false,
			});
		}
	}

	// Back to top button
	$(document).on('click', '[data-back-to-top]', function (e) {
		e.preventDefault();
		window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
	});
});

